import { ApiError } from '@/lib/api'
import { hasFieldErrors } from '@/lib/contacts/errors'
import type {
  DuplicateSuggestion,
  DuplicateSuggestionContact,
  SelectedDuplicatePair,
  SuggestionListState,
} from '@/pages/DuplicateReviewPage.types'

export interface ComparisonRow {
  label: string
  field: string
  left: string
  right: string
  conflict: boolean
}

export function selectedPairContacts(
  suggestion: DuplicateSuggestion,
  survivorId: number | null,
): SelectedDuplicatePair {
  const left = suggestion.contact_one
  const right = suggestion.contact_two
  const survivor = survivorId === right.id ? right : left
  const merged = survivor.id === left.id ? right : left

  return { survivor, merged }
}

export function apiErrorMessage(error: Error) {
  if (error instanceof ApiError && hasFieldErrors(error.body)) {
    return Object.values(error.body.errors).flat()[0] ?? error.message
  }

  return error.message
}

export function comparisonRows(
  left: DuplicateSuggestionContact,
  right: DuplicateSuggestionContact,
): ComparisonRow[] {
  return [
    {
      label: 'Name',
      field: 'name',
      left: displayValue(left.name),
      right: displayValue(right.name),
      conflict: left.name !== right.name,
    },
    {
      label: 'Email',
      field: 'email',
      left: displayValue(left.email),
      right: displayValue(right.email),
      conflict: (left.email ?? '') !== (right.email ?? ''),
    },
    {
      label: 'Type',
      field: 'contact_type',
      left: left.contact_type,
      right: right.contact_type,
      conflict: left.contact_type !== right.contact_type,
    },
  ]
}

export function placeholderTitle(state: SuggestionListState) {
  if (state === 'loading') return 'Loading Duplicate Suggestions'
  if (state === 'error') return 'Duplicate Suggestions unavailable'

  return 'No Duplicate Suggestions'
}

export function placeholderDescription(state: SuggestionListState) {
  if (state === 'error') return 'Refresh and try again.'
  if (state === 'ready') return 'The review queue is clear.'

  return undefined
}

function displayValue(value: string | null) {
  return value && value.length > 0 ? value : '-'
}
